/**
 * Better-Auth client factory for apps/web and apps/admin.
 *
 * Apps call `createAuthClient({ baseURL })` and re-export the result for
 * useSession / signIn / signOut / etc.
 */

import { createAuthClient as createBaseClient } from "better-auth/react";
import { adminClient, twoFactorClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";
import { ac, roles } from "./permissions.ts";

export interface CreateAuthClientInput {
  baseURL: string;
}

export function createAuthClient(input: CreateAuthClientInput) {
  return createBaseClient({
    baseURL: input.baseURL,
    plugins: [adminClient({ ac, roles }), twoFactorClient(), passkeyClient()],
  });
}

export type AuthClient = ReturnType<typeof createAuthClient>;
